import React from "react";
import { Card } from "antd";
import "./CustomCard.css";

const CustomCard = (props) => {
  let classes = "default-card";
  if (props.className) {
    classes = classes.concat(" ").concat(props.className);
  }

  return (
    <Card bordered={false} {...props} className={classes} style={{padding:"10px"}} styles={{actions:{padding:"",margin:"0px"},}} >
      {props.children}
    </Card>
  );
};

export default CustomCard;
